import { render } from "./Navbar.vue?vue&type=template&id=83a34c9c&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=83a34c9c&lang=scss&scoped=true"
import "./Navbar.vue?vue&type=style&index=1&id=83a34c9c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a34c9c"]])

export default __exports__